import { useCallback } from 'react'
import { setOrderInProgress, updateSavedPayment } from '../../actions/order'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedOrder } from '../../selectors/order'
import { setCartFromTab } from '../../actions/cart'
import { printOrder } from '../../actions/printer'

const useBackBar = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const order = useSelector(getSelectedOrder)

  /**
   * On "Print Check", prints the order as is anbd redirects to the orders page
   */
  const printCheckHandler = useCallback(() => {
    dispatch(
      printOrder({
        orderUuid: order?.uuid,
        isNewOrder: false,
        redirectionRoute: '/orders',
      }),
    )
  }, [dispatch, order?.uuid])

  /**
   * On "Print Slip", sets the order in progress and redirects to
   * the discounts page if discounts are available
   */
  const printSlipHandler = useCallback(() => {
    // check if order has payment attached already
    dispatch(setOrderInProgress(order))
    dispatch(setCartFromTab(order))

    history.push('/tender-selection')
  }, [dispatch, history, order])

  /**
   * On "Confirm Tip & Close Tab", sets the order in progress and
   * updates the saved payment
   *
   * @param {number} tipAmountInCents
   */
  const confirmTipHandler = useCallback(
    (tipAmountInCents) => {
      dispatch(setOrderInProgress(order))
      dispatch(updateSavedPayment({ tipAmountInCents, isBackBar: true }))
    },
    [dispatch, order],
  )

  return {
    confirmTipHandler,
    printCheckHandler,
    printSlipHandler,
  }
}

export default useBackBar
